"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationWithdrawOtpDeliveryMethod = exports.ApplicationWithdrawError = void 0;
/** `APIResponse.error` values returned by the /applicationWithdraw endpoints. */
var ApplicationWithdrawError;
(function (ApplicationWithdrawError) {
    ApplicationWithdrawError["INVALID_PHONE_NUMBER"] = "APPLICATION_WITHDRAW_INVALID_PHONE_NUMBER";
    ApplicationWithdrawError["CODE_DELIVERY_FAILED"] = "APPLICATION_WITHDRAW_CODE_DELIVERY_FAILED";
    ApplicationWithdrawError["INCORRECT_CODE"] = "APPLICATION_WITHDRAW_INCORRECT_CODE";
    ApplicationWithdrawError["NOT_WITHDRAWABLE"] = "APPLICATION_WITHDRAW_NOT_WITHDRAWABLE";
})(ApplicationWithdrawError || (exports.ApplicationWithdrawError = ApplicationWithdrawError = {}));
/** How the applicant identifies themselves, which is also where their verification code is sent. */
var ApplicationWithdrawOtpDeliveryMethod;
(function (ApplicationWithdrawOtpDeliveryMethod) {
    ApplicationWithdrawOtpDeliveryMethod["sms"] = "sms";
    ApplicationWithdrawOtpDeliveryMethod["email"] = "email";
})(ApplicationWithdrawOtpDeliveryMethod || (exports.ApplicationWithdrawOtpDeliveryMethod = ApplicationWithdrawOtpDeliveryMethod = {}));
